import React from 'react';
import { Button, Modal, Toast } from '@kaleyra/emmy';
import Styles from './index.module.scss';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

export type BaseSeeMorePropsType = {
    visible: boolean;
    id: any;
    appid: any;
    filters: any;
    SearchStr: string;
};

export type DispatchPropsType = {
    onClose: () => void;
    onDelete: (id: string, appid: string, callback: (resp: any, flag: boolean) => void) => void;
    onLoad: (filters?: any, SearchStr?: string) => void;
}

const DeleteModal: React.FC<BaseSeeMorePropsType & DispatchPropsType> = ({ onClose, onDelete, visible, id, appid, onLoad, filters, SearchStr }) => {
    const { t } = useTranslation();
    const handleDelete = () => {
        onDelete(id.id, appid.appid, deleteCallback);
    }

    const deleteCallback = (response: any, flag: boolean) => {
        if (response && flag) {
            onClose();
            Toast(response?.message, "success");
            onLoad(filters, SearchStr);
        } else {
            Toast(response?.message, "error")
        }
    }

    const renderFooterBody = () => {
        return (
            <>
                <Button type="tertiary" onClick={() => { onClose() }}>{t('mainDontDelete')}</Button>
                <Button className={Styles.deleteBtn} type="danger" onClick={() => handleDelete()}>{t('KLR01800')}</Button>
            </>
        )
    }

    return (
        <Modal
            visible={visible}
            title={'Confirmation'}
            body={<span>{t('BLD02000')}</span>}
            footer={renderFooterBody()}
        />
    );
}

export default DeleteModal;